import { Component, OnInit, OnDestroy } from '@angular/core';

import { select } from '@angular-redux/store';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'gl-header-shopping-cart',
    templateUrl: './header-shopping-cart.component.html',
    styleUrls: ['./header-shopping-cart.component.scss']
})
export class HeaderShoppingCartComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    @select(['cart', 'docNums']) docNums$: Observable<any[]>;
    @select(['cart', 'status']) status$: Observable<string>;
    @select(['cart', 'voucherTicket']) voucher$: Observable<string>;

    docNums;
    status;
    voucher;

    ngOnInit() {
        this.docNums$.pipe(takeUntil(this.componentDestroyed$)).subscribe((dn) => {
            this.docNums = dn;
        });

        this.status$.pipe(takeUntil(this.componentDestroyed$)).subscribe((s) => {
            this.status = s;
        });

        this.voucher$.pipe(takeUntil(this.componentDestroyed$)).subscribe((v) => {
            this.voucher = v;
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    getCount() {
        if (this.docNums.length && this.status !== 'Y') {
            if (this.voucher && this.voucher.id) {
                return '' + (this.docNums.length - 1);
            }
            return '' + this.docNums.length;
        }
        return '0';
    }
}
